module.exports = __webpack_public_path__ + "static/img/mx.45ad2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/flag/mx.png
// module id = lkO7
// module chunks = 0